import { AxiosRequestConfig, AxiosResponse } from "axios";
import { AppDispatch, AppGetState } from "../store";
import { IBwaIoGateway } from "../io/ioGateway";
import { getSiteLevelToken } from "./accessTokenManagerActions";
import { makeSimpleId } from "../utils";
import { error, log } from "./modules/logger/actions";
import {
  EVENT_HTTP_REQUEST_FAILED,
  EVENT_HTTP_REQUEST_SENT,
  EVENT_HTTP_REQUEST_SUCCEEDED,
} from "./modules/logger/constants";

export const siteContextRequest = (
  customerId: string,
  siteId: string,
  axiosRequestConfig: AxiosRequestConfig,
) => async (
  dispatch: AppDispatch,
  getState: AppGetState,
  { axios }: IBwaIoGateway,
): Promise<AxiosResponse> => {
  const accessToken = await dispatch(getSiteLevelToken(customerId, siteId));
  const reqId = `request_${makeSimpleId()}`;
  const { method, url, data } = axiosRequestConfig;
  dispatch(
    log(
      EVENT_HTTP_REQUEST_SENT,
      "1",
      `${reqId} [...${accessToken.slice(
        -10,
      )}] ${method} ${url} ${JSON.stringify(data)}`,
    ),
  );
  return axios({
    ...axiosRequestConfig,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
    .then(resp => {
      dispatch(log(EVENT_HTTP_REQUEST_SUCCEEDED, "1", reqId));
      return resp;
    })
    .catch(err => {
      dispatch(
        error(EVENT_HTTP_REQUEST_FAILED, "1", `${reqId} ${err.message}`),
      );
      throw err;
    })
    .then(handleApiResponse, handleApiResponse);
};

export const handleApiResponse = (resp: any) => {
  if (resp.status >= 200 && resp.status < 300) {
    if (resp.status === 204) {
      // no content
      return { data: {} };
    }

    return resp || { data: {} };
  }

  // if request fails, than we get an error in a first argument
  const err = resp;

  if (err && err.response && err.response.data && err.response.data.error) {
    // Server generated an error
    throw err.response.data.error;
  }

  throw {
    reason: getErrType(),
    message: err.response.statusText || null,
    payload: err.response
      ? err.response.data || err.response.error || null
      : err,
  };

  function getErrType() {
    if (err.response.status === 401 || err.response.status === 403) {
      return "auth";
    } else if ((err.response.status + "")[0] === "4") {
      return "client";
    } else if ((err.response.status + "")[0] === "5") {
      return "server";
    } else {
      return "unknown";
    }
  }
};
